import { c as _c } from "react/compiler-runtime";
export const RequirementRow = t0 => {
  const $ = _c(12);
  const {
    icon,
    title,
    subtitle
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-surface-weak bg-surface-strong text-surface-foreground">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <span className="text-base leading-6 text-surface-foreground">{title}</span>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subtitle) {
    t3 = <span className="text-sm leading-5 text-surface-foreground-weak">{subtitle}</span>;
    $[4] = subtitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <span className="flex min-w-0 flex-1 flex-col gap-0.5">{t2}{t3}</span>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="flex w-full items-center gap-3 rounded-sheet-inset bg-surface px-5 py-3">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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